'use client';

import React, { useState } from 'react';
import ProfileSettings from './ProfileSettings';
import SenderDomainsSettings from './SenderDomainsSettings';
import TeamMembersSettings from './TeamMembersSettings';
import NotificationsSettings from './NotificationsSettings';
import BillingSettings from './BillingSettings';
import { User, Globe, Users, Bell, CreditCard } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const tabs = [
  { id: 'profile', label: 'Profile', icon: User },
  { id: 'domains', label: 'Sender Domains', icon: Globe },
  { id: 'team', label: 'Team Members', icon: Users },
  { id: 'notifications', label: 'Notifications', icon: Bell },
  { id: 'billing', label: 'Billing', icon: CreditCard },
];

export default function SettingsClient() {
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage your account, sender domains, team, and billing</p>
      </div>
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Tab nav */}
        <div className="lg:w-52 flex-shrink-0">
          <nav className="space-y-1">
            {tabs?.map((tab) => {
              const Icon = tab?.icon;
              return (
                <button
                  key={`settings-tab-${tab?.id}`}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 ${
                    activeTab === tab?.id
                      ? 'bg-primary/10 text-primary font-semibold' :'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon size={16} />
                  {tab?.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {activeTab === 'profile' && <ProfileSettings />}
          {activeTab === 'domains' && <SenderDomainsSettings />}
          {activeTab === 'team' && <TeamMembersSettings />}
          {activeTab === 'notifications' && <NotificationsSettings />}
          {activeTab === 'billing' && <BillingSettings />}
        </div>
      </div>
    </div>
  );
}